import React, { Component } from 'react';
import { Card, CardBody, CardLink, Button, Modal, ModalHeader, ModalBody, Col, Row, Label, Form, Input } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModEstudiante from '../../Paginas/Admin/modEstudiante'
import modificarImg from '../../Img/modificar.png'
import eliminarImg from '../../Img/eliminar.png'
import { toast } from 'react-toastify';


export default class estudianteCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDelModalOpen: null,
            isModModalOpen: null,
            isViewModalOpen: null,
            seleccionAspirante: [],
            id: "",
            lista: [],
        }

        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
        this.toggleView = this.toggleView.bind(this)
        this.dateToString = this.dateToString.bind(this)
        this.onSeleccionAspirante = this.onSeleccionAspirante.bind(this)
    }

    onSeleccionAspirante(ev, ficha) {
        var tmp = this.state.seleccionAspirante

        if (ev.target.checked) {
            tmp.push(ficha)
        } else {
            var index = tmp.indexOf(ficha)
            tmp.splice(index, 1)
        }
        console.log(tmp)
        this.setState({ seleccionAspirante: tmp })
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    toggleMod(obj) {
        if (obj) {
            obj.lista = this.sort(obj.lista)
            this.setState({
                isModModalOpen: obj,
                lista: JSON.parse(JSON.stringify(obj.lista))
            })

        } else {
            this.setState({
                isModModalOpen: null,
            })
        }

    }

    sort(array) {
        var arr = array;
        for (var x = 0; x < arr.length; x++) {
            for (var y = 0; y < arr.length; y++) {
                if (arr[x] < arr[y]) {
                    var tmp = arr[x];
                    arr[x] = arr[y];
                    arr[y] = tmp;
                }
            }
        }
        return arr;
    }

    toggleView(obj) {
        if (obj) {
            obj.lista = this.sort(obj.lista)
            this.setState({ isViewModalOpen: obj })
        } else {
            this.setState({ isViewModalOpen: null })
        }

    }

    seleccionFicha(e, ficha) {
        if (e.currentTarget.checked) {
            e.target.style.backgroundColor = 'white';
            var array = this.state.lista
            var index = array.indexOf(ficha);
            array.splice(index, 1);
            this.setState({ lista: array })
        } else {
            e.target.style.backgroundColor = 'skyblue';
            var array = this.state.lista
            array.push(parseInt(ficha));
            this.setState({ lista: array })
        }

        e.currentTarget.checked = !e.currentTarget.checked;
    }

    guardarAsignacion() {
        var id = this.state.isModModalOpen._id
        var lista = this.sort(this.state.lista);

        Fetch('/api/updateAsignacionAspirante', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id, lista })
        })
            .then(response => {
                this.props.actualizarLista();
                this.toggleMod();
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 602:
                        console.log('Este elemento no existe')
                        break;
                    default:
                        toast.error("Error desconocido")
                        console.log(err)
                        break;
                }
            })

    }

    eliminar = (id) => {
        Fetch('/api/deleteAsignacionAspirante', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizarLista();
                this.toggleDel();

            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 602:
                        console.log('Este elemento no existe')
                        break;
                    default:
                        break;
                }
            })
    }

    dateToString(fecha) {
        var date = new Date(fecha);
        return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    }



    render() {
        return (
            <div className="col-12">
                <Card className="px-4 py-2">
                    <Row className="float-right">
                        <Col className="col-8"></Col>
                        <Col className="col-2 text-right">
                            <Button onClick={() => this.toggleDel(this.props.item._id)} className="bg-danger">X</Button>
                        </Col>

                        <Col className="col-2 text-right">
                            <Button onClick={() => this.toggleMod(this.props.item)} className="bg-primary">&#128393;</Button>
                        </Col>
                    </Row>

                    <Row>
                        <Label>Usuario:&nbsp;</Label>{this.props.item.usuario}
                    </Row>

                    <Row className="text-center">
                        <Col>
                            <Label className="btn text-primary font-weight-bold" onClick={() => this.toggleView(this.props.item)}>Ver listado</Label>
                        </Col>
                    </Row>
                </Card>

                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    ¿Esta seguro de que desea eliminar esta asignacion?
                                                        <div className="font-weight-bold">
                                        {this.props.doc}
                                    </div>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isViewModalOpen !== null} toggle={() => this.toggleView()}
                    className="modal-xl">
                    <ModalHeader toggle={() => this.toggleView()}>Ver</ModalHeader>
                    <ModalBody>
                        <Row>
                            {this.state.isViewModalOpen ? (this.state.isViewModalOpen.lista).map((ficha) => (
                                <Col className="col-2">
                                    <Card className="py-1 px-3">
                                        <Label className="my-auto text-center">Ficha: {ficha}</Label>
                                    </Card>
                                </Col>
                            )) : ""}
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-xl">
                    <ModalHeader toggle={() => this.toggleMod()}>Modificar</ModalHeader>
                    <ModalBody>
                        <Row className="mb-3">
                            <Col className="col-6">
                                <Button className="w-100 bg-success" onClick={() => this.guardarAsignacion()}>Guardar</Button>
                            </Col>
                            <Col className="col-6">
                                <Button className="w-100" onClick={() => this.toggleMod()} >Cancelar</Button>
                            </Col>
                        </Row>

                        <Row>
                            {this.props.aspirantesAsignables.length > 0 ? this.props.aspirantesAsignables.map(ficha => (
                                <Col className="col-1">
                                    <Button className="py-1 px-3 text-center text-dark mb-2" checked={false} style={{ backgroundColor: 'white' }} onClick={(e) => this.seleccionFicha(e, ficha)}>
                                        {ficha}
                                    </Button>
                                </Col>
                            )) : ""}
                        </Row>

                        <Row>
                            {this.state.isModModalOpen ? (this.state.isModModalOpen.lista).map(ficha => (
                                <Col className="col-1">
                                    <Button className="py-1 px-3 text-center text-dark mb-2" checked={true} style={{ backgroundColor: 'skyblue' }} onClick={(e) => this.seleccionFicha(e, ficha)}>
                                        {ficha}
                                    </Button>
                                </Col>
                            )) : ""}
                        </Row>
                    </ModalBody>
                </Modal>

            </div>
        )
    }
}

// {Array.from(this.state.aspirantesAsignables).length > 0 ? (this.state.aspirantesAsignables).map(elem => (
//     <Col className="col-4 mt-3">
//         <Card className="py-1 px-3">
//             <CardBody>
//                 <Row>
//                     <Col>
//                         <Form className="text-right">
//                             <Input type="checkbox" onChange={(ev) => this.onSeleccionAspirante(ev, elem.ficha)}></Input>
//                         </Form>
//                     </Col>
//                 </Row>

//                 <Row>
//                     <Label className="my-auto">Nombre:&nbsp;</Label>{elem.nombre + " " + elem.ap_paterno + " " + elem.ap_materno}                                                                           </Row>

//                 <Row>
//                     <Label className="my-auto">Ficha: #</Label>{elem.ficha}
//                 </Row>

//                 <Row>
//                     <Label className="my-auto">Curp:&nbsp;</Label>{elem.curp}
//                 </Row>
//             </CardBody>
//         </Card>
//     </Col>
// )) : ''}
// <CardBody>
//     <CardLink><Button className="btn-success" onClick={() => this.modificar(this.state.isModModalOpen._id, this.state.seleccionAspirante)}>Aceptar</Button></CardLink>
//     <CardLink><Button className="btn-light" onClick={() => this.toggleMod()}>Cancelar</Button></CardLink>
// </CardBody>

